import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error',
  imports: [ButtonComponent],
  templateUrl: './404.component.html',
  styleUrl: './404.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  constructor(private readonly _router: Router) {}

  public routeToHome() {
    this._router.navigate(['/']);
  }
}
